export default {
    XML_PATH_IS_GIFTCARD_ACTIVE: 'giftvoucher/general/active',
    XML_PATH_ALLOW_DISCOUNT_FOR_SHIPPING: 'giftvoucher/general/use_for_ship',
    XML_PATH_SHOW_GIFTCARD_PREFIX: 'giftvoucher/general/showprefix',
    XML_PATH_SHOW_HIDDEN_CHARACTER: 'giftvoucher/general/hiddenchar',
    XML_PATH_USE_WITH_COUPON: 'giftvoucher/general/use_with_coupon',
}



// WEBPACK FOOTER //
// ./src/view/constant/GiftcardConstant.js